// DS1.7.14
import React from 'react';
import c from 'classnames';
import s from './BetaBadge.scss';
const BetaBadge = ({ badgeType, size, variant, className, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(className, s['root'], s[`size-${size}`], s[`variant-${variant}`], badgeType === 'custom', s['is-custom-type'])
    }, badgeType === 'beta' && 'BETA', badgeType === 'new' && 'NEW!', badgeType === 'custom' && children);
};
BetaBadge.displayName = 'BetaBadge';
export default BetaBadge;
